export function isIPadOrIPhone(): boolean {
	return (
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) // iPad on iOS 13+
	);
}

export function setUpNestedScrollFix(cardsContainer: HTMLElement) {
	// Only apply the fix on iOS devices
	if (!isIPadOrIPhone()) {
		return () => {};
	}

	let startX = 0;
	let scrollLeft = 0;
	let isTouchActive = false;
	let shouldTriggerTocScroll = false;

	// Find the horizontal scrollable parent (app-container)
	const findHorizontalScrollableParent = (): HTMLElement | null => {
		let parent = cardsContainer.parentElement;
		while (parent) {
			const overflowX = window.getComputedStyle(parent).overflowX;
			if ((overflowX === 'scroll' || overflowX === 'auto') && parent.scrollWidth > parent.clientWidth) {
				return parent;
			}
			parent = parent.parentElement;
		}
		return null;
	};

	const scrollableParent = findHorizontalScrollableParent();

	if (!scrollableParent) {
		// console.warn('No horizontal scrollable parent found for cards container');
		return () => {};
	}

	const smoothScrollParentToStart = () => {
		scrollableParent.scrollTo({
			left: 0,
			behavior: 'smooth'
		});
	};

	const handleTouchStart = (e: TouchEvent) => {
		startX = e.touches[0].pageX;
		scrollLeft = cardsContainer.scrollLeft;
		isTouchActive = true;
		shouldTriggerTocScroll = false;
	};

	const handleTouchMove = (e: TouchEvent) => {
		if (!isTouchActive) return;

		const x = e.touches[0].pageX;
		const deltaX = startX - x;

		const isAtLeftEdge = scrollLeft <= 1;
		const isScrollingLeft = deltaX < 0; // Swiping right
		const swipeDistance = Math.abs(deltaX);

		// Check if conditions are met for TOC scroll
		const SWIPE_THRESHOLD = 50; // pixels

		if (isAtLeftEdge && isScrollingLeft && swipeDistance > SWIPE_THRESHOLD) {
			shouldTriggerTocScroll = true;
		} else {
			shouldTriggerTocScroll = false;
		}
	};

	const handleTouchEnd = () => {
		if (shouldTriggerTocScroll) {
			smoothScrollParentToStart();
			console.log('Triggered TOC scroll on touch end');
		}

		isTouchActive = false;
		shouldTriggerTocScroll = false;
	};

	cardsContainer.addEventListener('touchstart', handleTouchStart, {passive: true});
	cardsContainer.addEventListener('touchmove', handleTouchMove, {passive: true});
	cardsContainer.addEventListener('touchend', handleTouchEnd, {passive: true});
	cardsContainer.addEventListener('touchcancel', handleTouchEnd, {passive: true});

	return () => {
		cardsContainer.removeEventListener('touchstart', handleTouchStart);
		cardsContainer.removeEventListener('touchmove', handleTouchMove);
		cardsContainer.removeEventListener('touchend', handleTouchEnd);
		cardsContainer.removeEventListener('touchcancel', handleTouchEnd);
	};
}
